import { createSelector } from 'reselect';
export var getSelectedFares = function (state) { return state.newFlights; };
export var getNewFlightId = createSelector([getSelectedFares], function (fares) {
    if (fares.length) {
        return fares[0].fare.flightInfo.id;
    }
    return null;
});
